


import { menus } from './config'
import { updatePwd } from "@/api/login";
import { getDevCount, getPoliceCountAlarm, getPoliceCountUnactivated, getProStatus } from "@/api/homePage";
import { getPoliceHisList, getPoliceRead } from "@/api/warning";


import moment from 'moment';

export default {
    name: "home",
    data() {
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.ruleForm.newPassword) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            menu: null,
            defaultActive: this.$route.path,
            userName: '',

            pupUp: false,
            passwordFlag: false,

            ruleForm: {
                oldPassword: '',
                newPassword: '',
                confirmPassword: '',
            },
            rules: {
                oldPassword: [{ required: true, message: '请输入原密码', trigger: 'blur' }, { min: 6, max: 18, message: '长度在 6 到 18 个字符', trigger: 'blur' }],
                newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }, { min: 6, max: 18, message: '长度在 6 到 18 个字符', trigger: 'blur' }],
                confirmPassword: [{ required: true, validator: validatePass2, trigger: 'blur' }, { min: 6, max: 18, message: '长度在 6 到 18 个字符', trigger: 'blur' }],
            },

            gridData: [],

            deviceList: [
                {
                    src: require('../../assets/images/device/1.png'),
                    text: '总设备数量',
                    num: 0,
                    bgColor: '#00C0FF',
                }, {
                    src: require('../../assets/images/device/2.png'),
                    text: '在线设备数量',
                    num: 0,
                    bgColor: '#26E1AE',
                }, {
                    src: require('../../assets/images/device/3.png'),
                    text: '离线设备数量',
                    num: 0,
                    bgColor: '#FD964E',
                }, {
                    src: require('../../assets/images/device/4.png'),
                    text: '报警设备数量',
                    num: 0,
                    bgColor: '#FB5B79',
                }, {
                    src: require('../../assets/images/device/5.png'),
                    text: '未激活设备数量',
                    num: 0,
                    bgColor: '#C6C6C6',
                },
            ],

            

            timer: null,
        }
    },
    computed: {
        menus() {
            // let menus = JSON.parse(this.menu)
            // if (!menus) { return }
            // menus.forEach(item => {
            //     item.id = item.menuId
            //     if (item.menuType === 'C') {
            //         item.children = []
            //     }
            //     item.children.forEach(el => {
            //         el.id = el.menuId
            //         if (el.menuType === 'C') {
            //             el.children = []
            //         }
            //     })
            // });
            return menus;
        }
    },
    watch: {
        $route(to, from) {
            if(to.path==='/deviceDetails'){
                this.defaultActive = '/deviceList'
            }else{
                this.defaultActive = to.path ? to.path : from.path
            }
        },
        '$route.fullPath': {
            handler() {

                // this.getCurrentAlarmInformation()
                if (this.$route.fullPath == '/deviceList') {
                    this.getDevCount()//设备列表页的头部统计数据
                    // this.getCurrentAlarmInformation()//右上角报警
                    clearInterval(this.timer)
                    this.timer = setInterval(() => {
                        // this.getCurrentAlarmInformation()//右上角报警
                        this.getDevCount()//设备列表页的头部统计数据
                    }, 20000)
                } else {
                    clearInterval(this.timer)
                }
            },
            immediate: true

            // if(this.$route.fullPath!=='/deviceList' && this.$route.fullPath!=='/homePage'){
            //     clearInterval(this.timer)
            // }
        }

    },
    created() {
        // this.menu = sessionStorage.getItem('router')
        this.userName = sessionStorage.getItem("userName")
        // if(this.$route.fullPath == '/deviceList'){
        //     this.getDevCount()//设备列表页的头部统计数据
        //
        //     // this.getCurrentAlarmInformation()//右上角报警
        //     this.timer = setInterval(() => {
        //         // this.getCurrentAlarmInformation()//右上角报警
        //         this.getDevCount()//设备列表页的头部统计数据
        //     }, 10000)
        // }


    },
    mounted() {
        if (!sessionStorage.getItem("token")) {
            this.$router.push({ path: '/login' });
        }

        // this.bus.$on('alarm', (val) => {

        // });
    },

    beforeDestroy() {
        // this.bus.$off(['alarm'])
        clearInterval(this.timer)
    },
    methods: {

        async getCurrentAlarmInformation() {
            let params = {
                page: 1,
                offset: 10000000,
                sortBy: '',
                order: '',
                projectId: '', //项目id
                deviceIdent: [], //设备标识
                isRead: '',
                startTime: '',  //开始时间
                endTime: '', //结束时间
            }
            const res = await getPoliceHisList(params)
            if (res.code == 200) {
                let gridData = []
                let arr = []
                let data = res.data.rows
                data.forEach(el => {
                    // el.deviceStatus = res.data.stateJson[el.deviceIdent].deviceStatus
                    // if (el.process === 0) {
                    //     el.rulesState = 1
                    // } else {
                    //     if (el.deviceStatus === 3) {
                    //         el.rulesState = 1
                    //     } else {
                    //         el.rulesState = 0
                    //     }
                    // }
                    // if (el.rulesState === 0) return;

                    let trigAttrName = el.trigAttrName ? JSON.parse(el.trigAttrName) : []
                    let trigCondition = el.trigCondition ? JSON.parse(el.trigCondition) : []
                    let indexArr = this.findall(trigCondition || [], '%s')
                    for (let i = 0; i < indexArr.length; i++) {
                        trigCondition.splice(indexArr[i], 1, trigAttrName[i])
                    }
                    // res.data.proArr.map(item=>{
                    //     if(item.deviceIdent=== el.deviceIdent){
                    //         el.customer_id = item.customer_id
                    //     }
                    // })
                    arr.push(el.customer_id)
                    el.triggers = trigCondition.join('')
                    gridData.push(el)
                })
                this.gridData = gridData
            }
        },

        async handleClickRead(item) {
            this.$router.push({ path: '/alarmHistory', query: { data: item } });
        },


        async getDevCount() {
            const res = await getDevCount()//总数量
            if (res.code == 200) {// 总数量
                this.deviceList[0].num = res.data.tolNum
            }
            const res1 = await getProStatus()//在线统计
            if (res1.code == 200) {
                this.deviceList[1].num = res1.data.onlineDevCount //在线数量
                this.deviceList[2].num = res1.data.offlineDevCount //离线数量
                this.deviceList[4].num = res1.data.unActiveDevCount //未激活设备
            }
            const res2 = await getPoliceCountAlarm()//告警数
            if (res2.code == 200) {
                this.deviceList[3].num = res2.data //告警设备数
            }
            // const res3 = await getPoliceCountUnactivated()//未激活
            // if (res3.code == 200) {
            //     this.deviceList[4].num = res3.data //未激活设备数
            // }
        },

        handleOpen(key, keyPath) {
            // console.log(key, keyPath,7);
        },
        handleClose(key, keyPath) {
            // console.log(key, keyPath,8);
        },

        //退出登录确认按钮
        handleClickLogout() {
            this.$router.push({ path: '/login' });
        },

        //修改密码确认按钮
        async handleConfirmEditPassword() {
            let params = {
                oldPassword: this.ruleForm.oldPassword,
                newPassword: this.ruleForm.newPassword,
            }
            const res = await updatePwd(params)
            if (res.code == 200) {
                this.passwordFlag = false
                this.$refs['ruleForm'].resetFields();
                this.$message({
                    message: '修改成功',
                    type: 'success'
                });
            }
        },

        handleCancel() {
            this.$refs['ruleForm'].resetFields();
        },













        findall(a, x) {//查找数组中某个值出现的所有下标
            let results = [],
                len = a.length,
                pos = 0;
            while (pos < len) {
                pos = a.indexOf(x, pos);
                if (pos === -1) {//未找到就退出循环完成搜索
                    break;
                }
                results.push(pos);//找到就存储索引
                pos += 1;//并从下个位置开始搜索
            }
            return results;
        },
    },
}
